import { AppNavigationBar } from "app-navigation-bar";
import { MapProvider } from "react-map-gl/maplibre";
import { MapView as View } from "ui-components";

import { useGetCurrentMap } from "~map-view/queries/useGetCurrentMap";
import { useCurrentMapToolView } from "~map-view/states";

import { DrawerContent } from "./drawer-content";
import { Map } from "./map";
import { MapTools } from "./map-tools";

export const MapView = () => {
	const currentMapToolView = useCurrentMapToolView();
	useGetCurrentMap();

	return (
		<MapProvider>
			<AppNavigationBar>
				<View
					slots={{
						Map: <Map />,
						MapTools: <MapTools />,
						DrawerContent:
							currentMapToolView !== null ? <DrawerContent /> : null,
					}}
				/>
			</AppNavigationBar>
		</MapProvider>
	);
};
